module.exports = __webpack_public_path__ + "static/media/blog6.08933bcd.jpg";